export const baseLocale = 'de';
export const locales = ['en', 'de'];

export const isLocale = (locale) => locales.includes(locale);
